import ModifyReturnContainer from './ModifyReturnContainer';

const ModifyReturn = ModifyReturnContainer;

export default ModifyReturn;
